import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { logisticsAsset, officeAsset, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/officeAsset/video/rtlsVideo.mp4';

export default {
  desc: 'Khi tích hợp công nghệ RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) vào các giải pháp xây dựng văn phòng thông minh, chúng ta có thể làm cho môi trường làm việc trở nên thông minh hơn. RTLS là công nghệ theo dõi vị trí của tài sản và nhân viên theo thời gian thực, mang đến nhiều cơ hội đổi mới đa dạng trong văn phòng thông minh.',
  keywords: 'Văn phòng thông minh, quản lý kho, văn phòng phẩm, quản lý chấm công, van phong thong minh, quan ly kho, van phong pham, quan ly cham cong.',
  ogSite: 'Giải pháp xây dựng văn phòng thông minh',
  title: 'Giải pháp xây dựng văn phòng thông minh',
  ogUrl: 'https://orbro.io/vi/blog/officeSolution',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDz0dYjvT_dovrQIm8StET0JPtXyRSg67istWgj_G4Tk7ygKMfT0sSkYCFctUToVxdJt0GLQovf6SlDVOv8wRusG-hAYmfYmKYwY2UC2zapN2wPY8xmOdsmqfCmtKJE_ZgS5d3zp8jhdEh3kzrTI6wCtwXZsh2l8FoST49zwMy3hMKotCDruVcBK8e-90_kWC-DRfGXSqBUlqYqEvpb7suLGc-sG9uVyVzgpahbCluCQLjjYQp0FfaIMqi3qWmmpzn4UeKKFlFEKxo5npOoMkUfIPOIzQwrqMhKMvCPw19QwjLii04Vk779E1xu1B3yvdQA0SsTGt8xskOW8TEzvlXITVtsKdpUOAbHj6rKF-3gchc57T4eE_-3ycDx8gttnPLOy-milalJmjbIZrntwCeb8Qpocf-Ug-YSBcy46fdXlAD73CrLAkMZD_EibWYj6rcA1MkP7YlYgUDMFZsUHXCRAJn-FXeC1tFSMvFp9XkMXa0hQjhG7WFKQ9OY__bS3VMM3m653EIFAooJVI2JW5Lehmr8i7AoYvVwyVya-ECTAkyCOHE36ApWm2GXcuMaUEKVpFWCa6Uk5VT3y44pXzUjv7UyfKoAILkaIxCBJ90rb-hQj0SOmBbu6J5gp--cXveh_j_I1BpDL4yXkaY5roagR4KZV4HnPqPzoAuXRMkg9D1c2IIuxsH3XW2UbComnYB3ZP36_elzk3qsnT125p6OPuquaowy30SFBy65N7gknz-dVooAi8Bz_bREsVMZUQ1wevfQYy8CoL2buJo3oL-tQbJTKrbPBiZQYm3H1SZ7S9JXjEpyEJgoPnmvNE1Qk8ErzBGgEACyWUFED9vQmLonSf0sPZK2ipPzAfbSStrz0RdsuLXHASIrTRRXO2miidoWuq4JqeuHAzVXqVj8iiG6VnQSMN8hW29RelzkAFwfOg9QGOSQgroVEuHNbCZebcAa-WfMSPdOvklsFWIQIc7tEZ0Qc4oKkpyced7b9OF6nQAwaZH0Risyrl_jcCKd0dYWRazieZBi2P6EV3VqCdtI8xhpYvCer4uocgKohjK07UgUVaEC2ug-oLsCYkNC1MeYrEvVkM6lJCnqihOdgUQ7-28FDGc1mmL-l0En06_GFIkCWjuUL84NZSglIuAjAgx-XkQSRl6j9XiV_O-vcqE8qmjky4mXV-Wn9Mj4AUexdJBDWX9R1CgPvFsXQlYaAKg7sPSYXzv9cfTPCRBBZZ7HExJ0g18NzVBpn3JlbO76m7WOsMm20NMcBW_rFgPVVbcx_RkjFJZGYalie3GY6mewgx_VeKktH5GAlyxmgXqT2JeF_1GcqN6AFrQoTW_QgkDDyUkqJW-_olrQiVqerertlIZ8GOosa2chps5Yw1iCaH01YmTgG8u9YCrqbwtWdL2wE1StruepZYCM4DRqCS22OLJySm6TTeql6iQAxR3n6gNFmWutp83Z87o_7FuetzaZmM6Z31Pk7JOVigfT3FgDClioeRwOy_k3WkXA_FWF4xSORqO21iqrYzkjTzZKHUAiEqUt7VNXIcfn_bWJE2wDSqElWPnqG6MDtJwqdm6CK-l1uGp3c=w2110-h1166',

  ogType: 'website',
  date: '2023-10-31',
  tag1: '#Vanphongthongminh',
  tag2: '#Quanlykho',
  tag3: '#Vanphongpham',
  tag4: '#Quanlychamcong',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Khi tích hợp công nghệ RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) vào các giải pháp xây dựng văn phòng thông minh, chúng ta có thể làm cho môi trường làm việc trở nên thông minh hơn. RTLS là công nghệ theo dõi vị trí của tài sản và nhân viên theo thời gian thực, mang đến nhiều cơ hội đổi mới đa dạng trong văn phòng thông minh.',
      dot: '',
    },
    {
      head: '1. Công nghệ RTLS và Văn phòng thông minh',
      subHead: '',
      desc: 'Công nghệ RTLS, viết tắt của Real-Time Location System (Hệ thống Theo dõi Vị trí Thời gian Thực), là một hệ thống thu thập và phân tích dữ liệu vị trí theo thời gian thực bằng cách sử dụng công nghệ truyền thông không dây và cảm biến. Việc áp dụng công nghệ này vào môi trường văn phòng thông minh có thể mang lại những lợi ích sau:',
      dot: '',
    },
    {
      head: '2. Ưu điểm',
      subHead: 'Quản lý tài sản',
      desc: 'Thông qua RTLS, có thể theo dõi chính xác tất cả tài sản trong văn phòng thông minh. Ví dụ, hệ thống đặt phòng họp có thể sử dụng dữ liệu RTLS để kiểm tra thiết bị trong phòng họp theo thời gian thực và cho phép đặt phòng. Điều này giúp ngăn chặn việc đặt phòng trùng lặp và tối đa hóa việc sử dụng tài nguyên phòng họp. Ngoài ra, bằng cách phân tích dữ liệu lịch sử di chuyển và vị trí tài sản, có thể tối ưu hóa vòng đời tài sản và lên kế hoạch kiểm tra định kỳ phòng ngừa.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Năng suất của nhân viên',
      desc: 'Nhân viên cần tìm một tài sản cụ thể có thể kiểm tra vị trí hiện tại của tài sản đó thông qua ứng dụng RTLS và di chuyển đến đó theo lộ trình ngắn nhất. Điều này cũng giúp tối ưu hóa lịch trình làm việc của nhân viên. Bằng cách sử dụng dữ liệu RTLS để phân tích mô hình làm việc của nhân viên và tối ưu hóa việc lập kế hoạch công việc, có thể nâng cao năng suất. Quan trọng hơn, khi nhân viên có thể thực hiện công việc một cách hiệu quả ở bất cứ đâu, mức độ hài lòng của người lao động sẽ tăng lên.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường an ninh',
      desc: 'Người quản lý có thể phát hiện việc truy cập vào các địa điểm không được phép và sử dụng hệ thống cảnh báo để thực hiện hành động ngay lập tức. Bằng cách giám sát dữ liệu vị trí của nhân viên, có thể phát hiện công việc trong các khu vực nguy hiểm và gửi cảnh báo cho nhân viên hoặc thực hiện hành động ngay lập tức. Ngoài ra, việc giám sát sự di chuyển và thay đổi vị trí của tài sản giúp ngăn chặn trộm cắp hoặc hư hỏng, đóng góp lớn vào việc tăng cường an ninh.',
      dot: '',
    },
    {
      head: '3. Giải pháp Văn phòng thông minh sử dụng RTLS',
      subHead: 'Hệ thống quản lý tài sản',
      desc: 'Hệ thống này theo dõi và quản lý tất cả tài sản trong văn phòng theo thời gian thực. Mỗi tài sản được gắn thẻ RTLS, và thông qua thẻ này, vị trí, lộ trình di chuyển và lịch sử sử dụng của tài sản được theo dõi. Người quản lý có thể kiểm tra vị trí của tất cả tài sản theo thời gian thực thông qua bảng điều khiển trên nền tảng web và nhanh chóng tìm thấy tài sản cần thiết. Hơn nữa, dựa trên thông tin vị trí tài sản, hệ thống giúp tối ưu hóa tỷ lệ sử dụng tài sản và tránh việc mua lại thiết bị cần thiết một cách thiếu cân nhắc.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Bảng điều khiển tình hình nhân viên',
      desc: 'Việc triển khai một bảng điều khiển giám sát vị trí của nhân viên theo thời gian thực trong môi trường văn phòng thông minh có thể tối ưu hóa lịch trình làm việc và sự hợp tác. Ví dụ, bằng cách liên kết với hệ thống đặt phòng họp, có thể xác nhận theo thời gian thực ai đang sử dụng phòng họp nào. Việc chia sẻ thông tin vị trí của nhân viên và thúc đẩy sự hợp tác giữa các nhân viên có thể nâng cao năng suất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kiểm soát môi trường và quản lý năng lượng',
      desc: 'Hệ thống chiếu sáng thông minh phát hiện vị trí của nhân viên và tự động điều chỉnh ánh sáng để tiết kiệm năng lượng và cung cấp một môi trường chiếu sáng thoải mái. Ngoài ra, hệ thống xác định vị trí của nhân viên để điều chỉnh nhiệt độ và giám sát chất lượng không khí nhằm duy trì một môi trường làm việc dễ chịu. Điều này giúp tối ưu hóa mức tiêu thụ năng lượng trong văn phòng và quản lý môi trường một cách thông minh.',
      dot: '',
    },
    {
      head: 'Lời kết',
      subHead: '',
      desc: 'Các giải pháp văn phòng thông minh thông qua RTLS đóng một vai trò quan trọng trong việc cải thiện môi trường làm việc ở nhiều khía cạnh như quản lý tài sản, năng suất của nhân viên, tăng cường an ninh, và nâng cao năng lực cạnh tranh của doanh nghiệp. Bằng cách tận dụng các giải pháp này, các tổ chức sẽ góp phần xây dựng một môi trường văn phòng thông minh và chuẩn bị cho tương lai.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
    ],
  },
};
